import * as React from 'react'

function SvgSpaRounded(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.84 2.617c1.61 1.97 2.48 4.34 2.64 6.76-1.28.69-2.46 1.57-3.49 2.63a13.867 13.867 0 00-3.49-2.63c.2-2.41 1.12-4.78 2.77-6.76.41-.5 1.16-.5 1.57 0zM8.9 11.972zm0 0a11.792 11.792 0 00-5.74-2.165c-.64-.06-1.17.47-1.11 1.11.45 4.8 3.65 8.78 7.98 10.33.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51 4.33-1.55 7.53-5.52 7.98-10.33a1.02 1.02 0 00-1.11-1.11c-3.71.36-6.9 2.42-8.85 5.39a12.23 12.23 0 00-3.078-3.216 5.107 5.107 0 00-.14-.087 3.22 3.22 0 01-.242-.156c.063.042.128.082.192.122.06.037.12.074.177.112z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgSpaRounded
